export const RequestTypeEnum = {
  NORMAL: '0', // 通常発注
  REQUEST: '1', // 発注申請
};

export const RequestType = [
  { label: '通常発注', value: RequestTypeEnum.NORMAL },
  { label: '発注申請', value: RequestTypeEnum.REQUEST },
];
